import React from 'react';

const Calendar: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M16 2C16.5523 2 17 2.44772 17 3V4H18L18.2969 4.01465C18.9835
      4.08291 19.6289 4.38671 20.1211 4.87891C20.6837 5.44151 21 6.20435
      21 7V19C21 19.7957 20.6837 20.5585 20.1211 21.1211C19.5585 21.6837
      18.7957 22 18 22H6C5.20435 22 4.44152 21.6837 3.87891 21.1211C3.38671
      20.6289 3.08291 19.9835 3.01465 19.2969L3 19V7C3 6.20435 3.3163
      5.44152 3.87891 4.87891C4.44152 4.3163 5.20435 4 6 4H7V3C7 2.44772
      7.44772 2 8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2
      16 2ZM5 19L5.00488 19.0986C5.02757 19.3276 5.12883 19.5429 5.29297
      19.707C5.48051 19.8946 5.73478 20 6 20H18C18.2652 20 18.5195 19.8946
      18.707 19.707C18.8946 19.5195 19 19.2652 19 19V12H5V19ZM10.1025
      14.0049C10.6067 14.0562 11 14.4823 11 15V17L10.9951 17.1025C10.9438
      17.6067 10.5177 18 10 18H8C7.44772 18 7 17.5523 7 17V15L7.00488
      14.8975C7.05621 14.3933 7.48232 14 8 14H10L10.1025 14.0049ZM6
      6C5.73478 6 5.4805 6.10543 5.29297 6.29297C5.10543 6.4805 5
      6.73478 5 7V10H19V7C19 6.73478 18.8946 6.48051 18.707 6.29297C18.5429
      6.12883 18.3276 6.02757 18.0986 6.00488L18 6H17V7C17 7.55228 16.5523
      8 16 8C15.4477 8 15 7.55228 15 7V6H9V7C9 7.55228 8.55228 8 8 8C7.44772
      8 7 7.55228 7 7V6H6Z`} fill="#475467"/>
  </svg>
);

export default Calendar;
